import { gql } from 'graphql-request';

export const ACCEPT_STAFF_INVITE = gql`
  mutation AcceptStaffInvite($invitationId: ID!) {
    coreEmployeeInvitations {
      acceptInvitation(input: { invitationId: $invitationId, isAccepted: true })
    }
  }
`;
